import _                                              from 'underscore';
import React, { FC }                                  from 'react';
import { formatOption, IFormatOptionValue }           from '../../../../util';
import { PreSelectedSelectField }                     from '../../../../types';
import { PROJECT_MILESTONES, PROJECT_MILESTONE_INFO } from '../../../../constants/ProductEnums';
import { useProjectTermDictionary }                   from '../../../../hooks/useTermDictionary';
import { SelectField }                                from '../../../components/forms';

interface Props extends PreSelectedSelectField {
	customMilestoneOptions?: IFormatOptionValue[]
}

const defaultProps: Props = {
	customMilestoneOptions: []
}

const Dropdown: FC<Props> = ( props ) => {
	
	let { getTerm }         = useProjectTermDictionary();
	let customMilestones    = _.compact( props.customMilestoneOptions ),
	    hasCustomMilestones = !_.isEmpty( customMilestones );
	
	let groupLabels = {
		project: 'Project Milestones',
		custom:  'Custom Milestones'
	}
	
	let options = [
		formatOption(
			PROJECT_MILESTONES.INVESTIGATIONALNEWDRUGAPPLICATIONFILING,
			getTerm( PROJECT_MILESTONE_INFO.INVESTIGATIONALNEWDRUGAPPLICATIONFILING.LABEL ),
			{ group: groupLabels.project }
		),
		formatOption(
			PROJECT_MILESTONES.P2TRIALSTART,
			getTerm( PROJECT_MILESTONE_INFO.P2TRIALSTART.LABEL ),
			{ group: groupLabels.project }
		),
		formatOption(
			PROJECT_MILESTONES.P2TRIALDATA,
			getTerm( PROJECT_MILESTONE_INFO.P2TRIALDATA.LABEL ),
			{ group: groupLabels.project }
		),
		formatOption(
			PROJECT_MILESTONES.P3TRIALSTART,
			getTerm( PROJECT_MILESTONE_INFO.P3TRIALSTART.LABEL ),
			{ group: groupLabels.project }
		),
		formatOption(
			PROJECT_MILESTONES.P3TRIALDATA,
			getTerm( PROJECT_MILESTONE_INFO.P3TRIALDATA.LABEL ),
			{ group: groupLabels.project }
		),
		formatOption(
			PROJECT_MILESTONES.NDASUBMISSION,
			getTerm( PROJECT_MILESTONE_INFO.NDASUBMISSION.LABEL ),
			{ group: groupLabels.project }
		),
		formatOption(
			PROJECT_MILESTONES.LAUNCHDATE,
			getTerm( PROJECT_MILESTONE_INFO.LAUNCHDATE.LABEL ),
			{ group: groupLabels.project }
		),
		formatOption(
			PROJECT_MILESTONES.NDAAPPROVAL,
			getTerm( PROJECT_MILESTONE_INFO.NDAAPPROVAL.LABEL ),
			{ group: groupLabels.project }
		),
	];
	
	if( hasCustomMilestones ){
		
		customMilestones = customMilestones.map( m => {
			return { ...m, group: groupLabels.custom }
		} )
		
		options = [ ...options, ...customMilestones ];
	}
	
	return (
		<SelectField
			useGroupNames={ hasCustomMilestones }
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

Dropdown.defaultProps = defaultProps;

export { Dropdown as ProjectTimeMilestonesDropdown };
